import { render, staticRenderFns } from "./UserVoice.vue?vue&type=template&id=51c9cecb&scoped=true"
import script from "./UserVoice.vue?vue&type=script&lang=js"
export * from "./UserVoice.vue?vue&type=script&lang=js"
import style0 from "./UserVoice.vue?vue&type=style&index=0&id=51c9cecb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c9cecb",
  null
  
)

export default component.exports